export default __webpack_public_path__ + "static/media/antipolo.aa0c7266.jpg";